import _ from "lodash";
import { call, put, takeLatest } from "redux-saga/effects";

import { Action } from "../../../actions/actions";
import { API } from "../../../api/api";
import { ConfigurationsActionTypes } from "../actions/actionTypes";
import { configurationsAPI } from "../api/api";
import { configurationsStoreSelectors } from "../store/store";

function* getGameInstances(action: Action) {
    try {
        const { skip, top, subsidiary } = action.payload;
        const gameInstances = yield call(() =>
            configurationsAPI.getGameInstances({ subsidiary, skip, top })
        );

        let bundles = configurationsStoreSelectors.gameBundles();
        const games = _.uniqBy(gameInstances.data["results"], "game.id");

        if (bundles.length > 0) {
            bundles.map(bundle => {
                bundle.games = bundle.games.filter(
                    game =>
                        games.findIndex(item => item.game.id == game.id) > -1
                );
                return bundle;
            });

            bundles = bundles.filter(bundle => bundle.games.length > 0);

            yield put({
                type: ConfigurationsActionTypes.GET_GAME_BUNDLES_SUCCESS,
                payload: {
                    bundles: bundles
                }
            });
        }

        yield put({
            type: ConfigurationsActionTypes.GET_GAME_INSTANCES_SUCCESS,
            payload: {
                results: games.map(gc => {
                    return {
                        id: gc.game.id,
                        game: { ...gc.game, name: gc.label },
                        subsidiary: gc.subsidiary,
                        identifier: gc.game.id,
                        description: gc.label
                    };
                })
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error fetching game instances.");

        yield put({
            type: ConfigurationsActionTypes.GET_GAME_INSTANCES_FAIL,
            payload: e
        });
    }
}

export function* getGameInstancesWatcher() {
    yield takeLatest(
        ConfigurationsActionTypes.GET_GAME_INSTANCES,
        getGameInstances
    );
}

function* getGameBundles(action: Action) {
    try {
        const gameBundles = yield call(() =>
            configurationsAPI.getGameBundles({
                skip: 0,
                top: 10000
            })
        );

        let games = configurationsStoreSelectors.gameInstances().results;
        let bundles = gameBundles.data.results.filter(bundle =>
            bundle.subsidiaries.includes(action.payload.subsidiary)
        );

        if (games.length > 0) {
            bundles.map(bundle => {
                bundle.games = bundle.games.filter(
                    game => games.findIndex(item => item.id == game.id) > -1
                );
                return bundle;
            });
        }

        bundles = bundles.filter(bundle => bundle.games.length > 0);

        yield put({
            type: ConfigurationsActionTypes.GET_GAME_BUNDLES_SUCCESS,
            payload: {
                bundles: bundles
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error fetching game bundles.");

        yield put({
            type: ConfigurationsActionTypes.GET_GAME_BUNDLES_FAIL,
            payload: e
        });
    }
}

export function* getGameBundlesWatcher() {
    yield takeLatest(
        ConfigurationsActionTypes.GET_GAME_BUNDLES,
        getGameBundles
    );
}
